export const OpusAiIcon: React.FC<{ className?: string; size?: number }> = ({
  className,
  size = 20,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_196_5418)">
      <rect
        width="20"
        height="20"
        rx="10"
        fill="url(#paint0_radial_196_5418)"
      />
      <g filter="url(#filter0_i_196_5418)">
        <circle cx="10" cy="10" r="10" fill="white" />
        <circle cx="10" cy="10" r="10" fill="url(#paint1_radial_196_5418)" />
      </g>
      <g filter="url(#filter1_di_196_5418)">
        <path
          d="M9.88897 3.43276C9.90461 3.30106 10.0957 3.30106 10.1114 3.43276L10.2425 4.53761C10.4117 5.96427 11.5365 7.08908 12.9632 7.25836L14.068 7.38946C14.1998 7.4051 14.1998 7.59621 14.068 7.61185L12.9632 7.74294C11.5365 7.91222 10.4117 9.03703 10.2425 10.4637L10.1114 11.5685C10.0957 11.7002 9.90461 11.7002 9.88897 11.5685L9.75787 10.4637C9.5886 9.03703 8.46378 7.91222 7.03712 7.74294L5.93227 7.61185C5.80057 7.59621 5.80057 7.4051 5.93227 7.38946L7.03712 7.25836C8.46378 7.08908 9.5886 5.96427 9.75787 4.53761L9.88897 3.43276Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: "overlay" }} filter="url(#filter2_f_196_5418)">
        <rect
          x="0.415039"
          y="10.2422"
          width="19.1696"
          height="10.6574"
          fill="#072EAD"
        />
      </g>
      <g style={{ mixBlendMode: "overlay" }} filter="url(#filter3_f_196_5418)">
        <path
          d="M-5.19043 15.5703H24.4982L16.2629 23.0444H4.49815L-5.19043 15.5703Z"
          fill="#072EAD"
        />
      </g>
      <path
        d="M14.1668 10.834C14.1668 13.1352 12.3013 15.0007 10.0002 15.0007C7.69898 15.0007 5.8335 13.1352 5.8335 10.834"
        stroke="white"
        strokeWidth="1.25"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_196_5418"
        x="0"
        y="0"
        width="20"
        height="20.2768"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.276817" />
        <feGaussianBlur stdDeviation="1.21107" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.886275 0 0 0 0 0.462745 0 0 0 1 0"
        />
        <feBlend
          mode="screen"
          in2="shape"
          result="effect1_innerShadow_196_5418"
        />
      </filter>
      <filter
        id="filter1_di_196_5418"
        x="5.2085"
        y="2.70898"
        width="9.5835"
        height="9.58398"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.3125" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_196_5418"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_196_5418"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.15625" />
        <feGaussianBlur stdDeviation="0.078125" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_196_5418"
        />
      </filter>
      <filter
        id="filter2_f_196_5418"
        x="-14.1178"
        y="-4.29068"
        width="48.2352"
        height="39.7239"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="7.26643"
          result="effect1_foregroundBlur_196_5418"
        />
      </filter>
      <filter
        id="filter3_f_196_5418"
        x="-22.8375"
        y="-2.07675"
        width="64.9826"
        height="42.7687"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="8.82353"
          result="effect1_foregroundBlur_196_5418"
        />
      </filter>
      <radialGradient
        id="paint0_radial_196_5418"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.0787 10.7874) rotate(-90) scale(10.7874)"
      >
        <stop stopColor="#859CFD" />
        <stop offset="0.55" stopColor="#ADBDFF" />
        <stop offset="1" stopColor="#FFE276" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_196_5418"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.0787 10.7874) rotate(-90) scale(10.7874)"
      >
        <stop stopColor="#859CFD" />
        <stop offset="0.55" stopColor="#ADBDFF" />
        <stop offset="1" stopColor="#FFE276" />
      </radialGradient>
      <clipPath id="clip0_196_5418">
        <rect width="20" height="20" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
